import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { AppConfig, Facet, FacetValue, SearchCriteria, FacetSearchCriteria } from "../webapi/faceted-search-app.model";
import { FacetedSearchAppService } from "../webapi/faceted-search-app.service";

@Component({
  selector: 'facet-list',
  templateUrl: './facet-list.component.html',
  styleUrls: ['./facet-list.component.css', '../facet/facet.component.css']
})


export class FacetListComponent implements OnInit {

  constructor(private facetedSearchAppService: FacetedSearchAppService) {
  }

  @Output()
  onChange = new EventEmitter<any>();

  facets: Facet[];

  onFacetSearchCriteriaChanged(e: any) {
    this.onChange.emit(e);
  }

  onTextSearchChanged(e: any) {
    this.onChange.emit(e);
  }

  onTextSearchCleared() {
    this.onChange.emit('');
  }

  ngOnInit(): void {
    this.facetedSearchAppService.facets().then(x => {
      this.facets = x.filter(x => x.visible);
    }).catch(() => { this.facets = null });

  }

}



// WEBPACK FOOTER //
// ./src/app/fsapplication/facet-list/facet-list.component.ts